import { Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import {
  GoalProgressContainer,
  GoalProgressLabelContainer,
} from './Goals.styled'

type GoalProgressProps = {
  showLabel?: boolean
  size: number
  value: number
}

export const GoalProgress = ({ showLabel, size, value }: GoalProgressProps) => (
  <GoalProgressContainer>
    <CircularProgress variant='determinate' value={value} size={size} />
    <GoalProgressLabelContainer>
      {showLabel && (
        <Typography
          variant='caption'
          component='div'
          color='text.secondary'
        >{`${Math.round(value)}%`}</Typography>
      )}
    </GoalProgressLabelContainer>
  </GoalProgressContainer>
)
